import styled from "@emotion/styled";

export const StyledContainer = styled.div`
  margin-right: auto;
  margin-left: auto;
  padding: 0 15px;
  width: 100%;
  max-width: 1200px;
`;
